import { Alert, Icon, Text } from '../index';
import * as React from 'react';
type Props =
  | {
      message: React.ReactNode;
      title?: React.ReactNode;
    }
  | {
      message?: React.ReactNode;
      title: React.ReactNode;
    }
  | {
      message: React.ReactNode;
      title: React.ReactNode;
    };
const ErrorMessage = ({ message, title }: Props) => {
  return (
    <Alert variant='danger' className='d-flex align-items-center'>
      <Icon icon='alert' size='sm' className='text-danger-text me-3' />
      <div>
        {title && (
          <Text color='danger' weight='bold'>
            {title}
          </Text>
        )}
        <Text color='danger' heading='xxs'>
          {message}
        </Text>
      </div>
    </Alert>
  );
};

export default ErrorMessage;
